<template>
    <div v-html="helphtml" class="pdfdiv">
      <!-- <img v-for="(item,index) in imgdata" :src="baseUrl.hbjx+'/upload/helpimg/'+item" alt=""> -->
      <!-- <iframe :src="baseUrl.hbjx+'/upload/helpimg/'+helphtml" width="100%" height="auto"></iframe> -->
    </div>
  </template>
  
  <script>
  import axios from "axios";
    export default {
      data() {
        return {
          // imgdata:['1.jpg','2.jpg','3.jpg','4.jpg','5.jpg','6.jpg','7.jpg','8.jpg'],
          helphtml:"",
        }
      },
      //初始化方法
      mounted() {
        this.getdata();
      },
      methods: {
        getdata() {
        axios.get(this.baseUrl.hbjx + '/upload/helpimg/help.html', {  //params参数必写 , 如果没有参数传{}也可以
          params: {}
        })
          .then((res) => {
            this.helphtml = res.data;
          })
          .catch(function (err) {
            console.log(err);
          });
      },
      }
    }
  </script>
  <style scoped>
    .pdfdiv {
      width: 1100px;
      height: auto;
      display: flex;
      flex-direction: column;
      padding: 50px 0px;
    }
  </style>


// WEBPACK FOOTER //
// src/components/HelpCenterPage.vue